import { CRUD } from "@/shared/components";
import { SubscriptionsListQuery } from "@/admin/entities/subscriptions";
import {
  useSubscriptionsManagement,
  type SubscriptionRow,
  SubscriptionsSchemas,
} from "../model";

/**
 * Реестр подписок. Только просмотр — редактирования, создания и
 * удаления нет.
 */
export function Subscriptions() {
  const { columns, mobileColumns, mapColumns, getTableData, texts } =
    useSubscriptionsManagement();

  return (
    <CRUD<SubscriptionRow>
      listQuery={SubscriptionsListQuery}
      getTableData={getTableData}
      mapColumns={mapColumns}
      columns={columns}
      filterSchema={SubscriptionsSchemas.filterSchema}
      normalizeFilter={SubscriptionsSchemas.normalizeSubscriptionsFilter}
      texts={texts}
      persistFilters
      hideCreateButton
      useMobileView
      mobileColumns={mobileColumns}
    />
  );
}
